import gql from "graphql-tag";

export const ASSIGN_THIRD_PARTY_TAX_SERVICE_TO_COMPANY = gql`
  mutation assignThirdPartyTaxServiceToCompany($clientId: String!, $thirdPartyId: String) {
    assignThirdPartyTaxServiceToCompany(clientId: $clientId, thirdPartyId: $thirdPartyId) {
      feedback
    }
  }
`;
